import useSWR from "swr";
import { useCreateProductServicePublicAxiosInstance } from "../../Auth/useCreateProductServicePublicAxiosInstance.ts";
import { PromoDTO } from "./useAllPromos.ts";

export function usePromoById(promoId: string) {
  const { createAxiosInstance } = useCreateProductServicePublicAxiosInstance();
  const { data, isLoading } = useSWR(`/promos/${promoId}`, async (url) => {
    const { data } = await createAxiosInstance().get<PromoDTO>(url);
    return data;
  });

  return {
    promo: data ?? null,
    isLoading,
  };
}
